import { configureStore } from '@reduxjs/toolkit'
import { reducer } from './rootReducer'
import createSagaMiddleware from 'redux-saga';

import watcherAuthSubmit from "./sagas/authSaga";
import watcherCheckToken from "./sagas/checkToken";
import watcherCurrentVisitors from "./sagas/currentVisitorsSaga";
import watcherEstablishmentList from "./sagas/establishmentListSaga";
import watcherCloseWorkout from "./sagas/closeWorkout";
import watcherGetStatistic from "./sagas/getStatisticSaga";
import watcherGetSubscriptions from "./sagas/getSubscriptionsSaga";
import watcherUpdateSubscription from "./sagas/updateSubscriptionSaga";
import watcherUpdateUser from "./sagas/updateUserSaga";
import watcherRemoveUser from "./sagas/removeUserSaga";
import watcherGetUsersForSubscription from "./sagas/getUsersForSubscriptionSaga";
import watcherGetSubscriptionData from "./sagas/getSubscriptionDataSaga";
import watcherAddSubscription from "./sagas/addSubscriptionSaga";
import watcherUpdateEstablishment from "./sagas/updateEstablishmentSaga";
import watcherUpdateSubscriptionType from "./sagas/updateSubscriptionTypeSaga";
import watcherUpdateSubscriptionDuration from "./sagas/updateSubscriptionDurationSaga";
import watcherUpdateSubscriptionWorkouts from "./sagas/updateSubscriptionWorkoutsSaga";
import watcherUpdateSubscriptionConstraint from "./sagas/updateSubscriptionConstraintSaga";
import watcherGetSubscriptionType from "./sagas/getSubscriptionTypeSaga";
import watcherGetSubscriptionDuration from "./sagas/getSubscriptionDurationSaga";
import watcherGetSubscriptionWorkout from "./sagas/getSubscriptionWorkoutSaga";
import watcherGetSubscriptionConstraint from "./sagas/getSubscriptionConstraintSaga";
import watcherRemoveSubscriptionType from "./sagas/removeSubscriptionTypeSaga";
import watcherRemoveSubscriptionDuration from "./sagas/removeSubscriptionDurationSaga";
import watcherRemoveSubscriptionWorkout from "./sagas/removeSubscriptionWorkoutSaga";
import watcherRemoveSubscriptionConstraint from "./sagas/removeSubscriptionConstraintSaga";
import watcherRemoveSubscription from "./sagas/remvoeSubscriptionSaga";
import watcherGetDataForQR from "./sagas/getDataForQRSaga";
import watcherSendMessages from "./sagas/sendMessagesSaga";
import watcherGetUserInfo from "./sagas/getUserInfoSaga";
import watcherGetUsersStatistic from "./sagas/getUsersStatisticSaga";
import watcherActivationSubscription from "./sagas/activationSubscriptionSaga";
import watcherSaveKeyNumber from "./sagas/saveKeyNumberSaga";
import watcherFindKeyNumber from "./sagas/findKeyNumberSaga";
import watcherGetWorkoutsFromCertainSubscription from "./sagas/getWorkoutsFromCertainSubscriptionSaga";
import watcherGetPromo from "./sagas/getPromoSaga";
import watcherUpdatePromo from "./sagas/updatePromoSaga";
import watcherRemovePromo from "./sagas/removePromoSaga";
import watcherSetQRSettings from "./sagas/setQRSettingsSaga";
import watcherGetPrice from "./sagas/getPriceSaga";
import watcherUpdatePrice from "./sagas/updatePriceSaga";
import watcherRemovePrice from "./sagas/removePriceSaga";
import watcherGetCoaches from "./sagas/getCoachesSaga";
import watcherUpdateCoach from "./sagas/updateCoachSaga";
import watcherRemoveCoach from "./sagas/removeCoachSaga";
import watcherRecordOneTimeWorkout from "./sagas/recordOneTimeWorkoutSaga";
import watcherGetSales from "./sagas/getSalesSaga";
import watcherGetCost from "./sagas/getCostSaga";
import watcherExportSalesToExcel from "./sagas/exportSalesToExcelSaga";
import watcherCopySubscription from "./sagas/copySubscriptionSaga";
import watcherGetPaymentMethod from "./sagas/getPaymentMethodSaga";
import watcherRemovePaymentMethod from "./sagas/removePaymentMethodSaga";
import watcherUpdatePayment from "./sagas/updatePaymentSaga";
import watcherRemovePayment from "./sagas/removePaymentSaga";
import watcherRepayMoneyForSubscription from "./sagas/repayMoneyForSubscriptionSaga";
import watcherUpdateBooking from "./sagas/updateBookingSaga";
import watcherRemoveBooking from "./sagas/removeBookingSaga";
import watcherGetBookingUsers from "./sagas/getBookingUsersSaga";
import watcherAddUserToBooking from "./sagas/addUserToBookinSaga";
import watcherRemoveUserFromBooking from "./sagas/removeUserFromBookingSaga";
import watcherGetSubscriptionInactiveDays from "./sagas/getSubscriptionInactiveDaysSaga";
import watcherUpdateSubscriptionInactiveDays from "./sagas/updateSubscriptionInactiveDaysSaga";
import watcherChangeWorkoutCoach from "./sagas/changeWorkoutCoachSaga";
import watcherGetFamilyList from "./sagas/getFamilyListSaga";
import watcherUpdateSubscriptionFamilyList from "./sagas/updateSubscriptionFamilyListSaga";
import watcherRemoveWorkout from "./sagas/removeWorkoutSaga";
import watcherChangeWorkoutType from "./sagas/changeWorkoutTypeSaga";
import watcherGetDiscount from "./sagas/getDiscountSaga";
import watcherUpdateDiscount from "./sagas/updateDiscountSaga";
import watcherRemoveDiscount from "./sagas/removeDiscountSaga";
import watcherGetGifts from "./sagas/getGiftsSaga";
import watcherUpdateGift from "./sagas/updateGiftSaga";
import watcherGetGiftById from "./sagas/getGiftByIdSaga";
import watcherRemoveGift from "./sagas/removeGiftSaga";
import watcherGetGiftsOrders from "./sagas/getGiftsOrdersSaga";
import watcherActionGiftOrder from "./sagas/actionGiftOrderSaga";
import watcherUpdateWorkoutCost from "./sagas/updateWorkoutCostSaga";
import watcherGetGoods from "./sagas/getGoodsSaga";
import watcherUpdateGoods from "./sagas/updateGoodsSaga";
import watcherGetGoodsById from "./sagas/getGoodsByIdSaga";
import watcherRemoveGoods from "./sagas/removeGoodsSaga";
import watcherGetGroups from "./sagas/getGroupsSaga";
import watcherUpdateGroup from "./sagas/updateGroupSaga";
import watcherGetGroupById from "./sagas/getGroupByIdSaga";
import watcherRemoveGroup from "./sagas/removeGroupSaga";
import watcherSaveGoodsPurchase from "./sagas/saveGoodsPurchaseSaga";
import watcherCopyBooking from "./sagas/copyBookingSaga";
import watcherCopyDayBooking from "./sagas/copyDayBookingSaga";
import watcherGetWeekBooking from "./sagas/getWeekBookingSaga";
import watcherSaveWebToken from "./sagas/saveWebTokenSaga";
import watcherExportUsersToExcel from "./sagas/exportUsersToExcelSaga";
import watcherUpdateTask from "./sagas/updateTaskSaga";
import watcherGetTasks from "./sagas/getTasksSaga";
import watcherGetTaskById from "./sagas/getTaskByIdSaga";
import watcherRemoveTask from "./sagas/removeTaskSaga";
import watcherArchiveTask from "./sagas/archiveTaskSaga";
import watcherCopyWeekBooking from "./sagas/copyWeekBookingSaga";
import watcherTransferUserData from "./sagas/transferUserDataSaga";
import watcherSetUserPermission from "./sagas/setUserPermissionSaga";
import watcherGetUserPermission from "./sagas/getUserPermissionSaga";
import watcherSendBookingNotification from "./sagas/sendBookingNotificationSaga";
import watcherChangeWorkoutDate from "./sagas/changeWorkoutDateSaga";
import watcherChangePaymentDate from "./sagas/changePaymentDateSaga";
import watcherFreezeSubscription from "./sagas/freezeSubscriptionSaga";
import watcherRemoveDebtWorkout from "./sagas/removeDebtWorkoutSaga";
import watcherSort from "./sagas/sortSaga";
import watcherConfirmEmail from "./sagas/confirmEmailSaga";
import watcherCancelBooking from "./sagas/cancelBookingSaga";
import watcherGetPromoGoods from "./sagas/getPromoGoodsSaga";
import watcherUpdatePromoGoods from "./sagas/updatePromoGoodsSaga";
import watcherUploadFile from "./sagas/uploadFileSaga";
import watcherRemoveMissedWorkout from "./sagas/removeMissedWorkoutSaga";
import watcherDeactivateSubscription from "./sagas/deactivateSubscriptionSaga";
import watcherSetUserSettings from "./sagas/setUserSettingsSaga";
import watcherGetAutomation from "./sagas/getAutomationSaga";
import watcherUpdateBirthdayAutomation from "./sagas/updateBirthdayAutomationSaga";
import watcherRemoveBirthdayAutomation from "./sagas/removeBirthdayAutomationSagaAction";
import watcherGetAdminById from "./sagas/getAdminByIdSaga";
import watcherUpdateAdminById from "./sagas/updateAdminByIdSaga";
import watcherRemoveAdminById from "./sagas/removeAdminByIdSaga";
import watcherGetDepositsList from "./sagas/getDepositListSaga";
import watcherUpdateDeposit from "./sagas/updateDepositSaga";
import watcherGetDepositById from "./sagas/getDepositByIdSaga";
import watcherRemoveDeposit from "./sagas/removeDepositSaga";
import watcherWorkoutPayment from "./sagas/workoutPaymentSaga";
import watcherResetAdminPassword from "./sagas/resetAdminPassword";
import watcherChangeUnlimSubscription from "./sagas/changeUnlimSubscriptionSaga";
import watcherUpdateGoodsRest from "./sagas/updateGoodsRestSaga";
import watcherExportGoodsRestToExcel from "./sagas/exportGoodsRestToExcelSaga";
import watcherGetSalaries from "./sagas/getSalariesSaga";
import watcherGetLeaderboard from "./sagas/getLeaderboardSaga";
import watcherGetAvailableSubscriptions from "./sagas/getAvailableSubscriptionsSaga";
import watcherAddWorkoutByAvailableSubscription from "./sagas/addWorkoutByAvailableSubscriptionSaga";
import watcherGetLastBooking from "./sagas/getLastBookingSaga";
import watcherGetChildren from "./sagas/getChildrenSaga";
import watcherGetChildById from "./sagas/getChildByIdSaga";
import watcherUpdateChild from "./sagas/updateChildSaga";
import watcherRemoveChild from "./sagas/removeChildSaga";
import watcherGetReviews from "./sagas/getReviewsSaga";
import watcherGenerateInvoice from "./sagas/generateInvoiceSaga";

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            thunk: true,
        }).concat(sagaMiddleware)
});

export default store

sagaMiddleware.run(watcherAuthSubmit);
sagaMiddleware.run(watcherCheckToken);
sagaMiddleware.run(watcherCurrentVisitors);
sagaMiddleware.run(watcherEstablishmentList);
sagaMiddleware.run(watcherCloseWorkout);
sagaMiddleware.run(watcherGetStatistic);
sagaMiddleware.run(watcherGetSubscriptions);
sagaMiddleware.run(watcherUpdateSubscription);
sagaMiddleware.run(watcherUpdateUser);
sagaMiddleware.run(watcherRemoveUser);
sagaMiddleware.run(watcherGetUsersForSubscription);
sagaMiddleware.run(watcherGetSubscriptionData);
sagaMiddleware.run(watcherAddSubscription);
sagaMiddleware.run(watcherUpdateEstablishment);
sagaMiddleware.run(watcherUpdateSubscriptionType);
sagaMiddleware.run(watcherUpdateSubscriptionDuration);
sagaMiddleware.run(watcherUpdateSubscriptionWorkouts);
sagaMiddleware.run(watcherUpdateSubscriptionConstraint);
sagaMiddleware.run(watcherGetSubscriptionType);
sagaMiddleware.run(watcherGetSubscriptionDuration);
sagaMiddleware.run(watcherGetSubscriptionWorkout);
sagaMiddleware.run(watcherGetSubscriptionConstraint);
sagaMiddleware.run(watcherRemoveSubscriptionType);
sagaMiddleware.run(watcherRemoveSubscriptionDuration);
sagaMiddleware.run(watcherRemoveSubscriptionWorkout);
sagaMiddleware.run(watcherRemoveSubscriptionConstraint);
sagaMiddleware.run(watcherRemoveSubscription);
sagaMiddleware.run(watcherGetDataForQR);
sagaMiddleware.run(watcherSendMessages);
sagaMiddleware.run(watcherGetUserInfo);
sagaMiddleware.run(watcherGetUsersStatistic);
sagaMiddleware.run(watcherActivationSubscription);
sagaMiddleware.run(watcherSaveKeyNumber);
sagaMiddleware.run(watcherFindKeyNumber);
sagaMiddleware.run(watcherGetWorkoutsFromCertainSubscription);
sagaMiddleware.run(watcherGetPromo);
sagaMiddleware.run(watcherUpdatePromo);
sagaMiddleware.run(watcherRemovePromo);
sagaMiddleware.run(watcherSetQRSettings);
sagaMiddleware.run(watcherGetPrice);
sagaMiddleware.run(watcherUpdatePrice);
sagaMiddleware.run(watcherRemovePrice);
sagaMiddleware.run(watcherGetCoaches);
sagaMiddleware.run(watcherUpdateCoach);
sagaMiddleware.run(watcherRemoveCoach);
sagaMiddleware.run(watcherRecordOneTimeWorkout);
sagaMiddleware.run(watcherGetSales);
sagaMiddleware.run(watcherGetCost);
sagaMiddleware.run(watcherExportSalesToExcel);
sagaMiddleware.run(watcherCopySubscription);
sagaMiddleware.run(watcherGetPaymentMethod);
sagaMiddleware.run(watcherRemovePaymentMethod);
sagaMiddleware.run(watcherUpdatePayment);
sagaMiddleware.run(watcherRemovePayment);
sagaMiddleware.run(watcherRepayMoneyForSubscription);
sagaMiddleware.run(watcherUpdateBooking);
sagaMiddleware.run(watcherRemoveBooking);
sagaMiddleware.run(watcherGetBookingUsers);
sagaMiddleware.run(watcherAddUserToBooking);
sagaMiddleware.run(watcherRemoveUserFromBooking);
sagaMiddleware.run(watcherGetSubscriptionInactiveDays);
sagaMiddleware.run(watcherUpdateSubscriptionInactiveDays);
sagaMiddleware.run(watcherChangeWorkoutCoach);
sagaMiddleware.run(watcherGetFamilyList);
sagaMiddleware.run(watcherUpdateSubscriptionFamilyList);
sagaMiddleware.run(watcherRemoveWorkout);
sagaMiddleware.run(watcherChangeWorkoutType);
sagaMiddleware.run(watcherGetDiscount);
sagaMiddleware.run(watcherUpdateDiscount);
sagaMiddleware.run(watcherRemoveDiscount);
sagaMiddleware.run(watcherGetGifts);
sagaMiddleware.run(watcherUpdateGift);
sagaMiddleware.run(watcherGetGiftById);
sagaMiddleware.run(watcherRemoveGift);
sagaMiddleware.run(watcherGetGiftsOrders);
sagaMiddleware.run(watcherActionGiftOrder);
sagaMiddleware.run(watcherUpdateWorkoutCost);
sagaMiddleware.run(watcherGetGoods);
sagaMiddleware.run(watcherUpdateGoods);
sagaMiddleware.run(watcherGetGoodsById);
sagaMiddleware.run(watcherRemoveGoods);
sagaMiddleware.run(watcherGetGroups);
sagaMiddleware.run(watcherUpdateGroup);
sagaMiddleware.run(watcherGetGroupById);
sagaMiddleware.run(watcherRemoveGroup);
sagaMiddleware.run(watcherSaveGoodsPurchase);
sagaMiddleware.run(watcherCopyBooking);
sagaMiddleware.run(watcherCopyDayBooking);
sagaMiddleware.run(watcherGetWeekBooking);
sagaMiddleware.run(watcherSaveWebToken);
sagaMiddleware.run(watcherExportUsersToExcel);
sagaMiddleware.run(watcherUpdateTask);
sagaMiddleware.run(watcherGetTasks);
sagaMiddleware.run(watcherGetTaskById);
sagaMiddleware.run(watcherRemoveTask);
sagaMiddleware.run(watcherArchiveTask);
sagaMiddleware.run(watcherCopyWeekBooking);
sagaMiddleware.run(watcherTransferUserData);
sagaMiddleware.run(watcherSetUserPermission);
sagaMiddleware.run(watcherGetUserPermission);
sagaMiddleware.run(watcherSendBookingNotification);
sagaMiddleware.run(watcherChangeWorkoutDate);
sagaMiddleware.run(watcherChangePaymentDate);
sagaMiddleware.run(watcherFreezeSubscription);
sagaMiddleware.run(watcherRemoveDebtWorkout);
sagaMiddleware.run(watcherSort);
sagaMiddleware.run(watcherConfirmEmail);
sagaMiddleware.run(watcherCancelBooking);
sagaMiddleware.run(watcherGetPromoGoods);
sagaMiddleware.run(watcherUpdatePromoGoods);
sagaMiddleware.run(watcherUploadFile);
sagaMiddleware.run(watcherRemoveMissedWorkout);
sagaMiddleware.run(watcherDeactivateSubscription);
sagaMiddleware.run(watcherSetUserSettings);
sagaMiddleware.run(watcherGetAutomation);
sagaMiddleware.run(watcherUpdateBirthdayAutomation);
sagaMiddleware.run(watcherRemoveBirthdayAutomation);
sagaMiddleware.run(watcherGetAdminById);
sagaMiddleware.run(watcherUpdateAdminById);
sagaMiddleware.run(watcherRemoveAdminById);
sagaMiddleware.run(watcherGetDepositsList);
sagaMiddleware.run(watcherUpdateDeposit);
sagaMiddleware.run(watcherGetDepositById);
sagaMiddleware.run(watcherRemoveDeposit);
sagaMiddleware.run(watcherWorkoutPayment);
sagaMiddleware.run(watcherResetAdminPassword);
sagaMiddleware.run(watcherChangeUnlimSubscription);
sagaMiddleware.run(watcherUpdateGoodsRest);
sagaMiddleware.run(watcherExportGoodsRestToExcel);
sagaMiddleware.run(watcherGetSalaries);
sagaMiddleware.run(watcherGetLeaderboard);
sagaMiddleware.run(watcherGetAvailableSubscriptions);
sagaMiddleware.run(watcherAddWorkoutByAvailableSubscription);
sagaMiddleware.run(watcherGetLastBooking);
sagaMiddleware.run(watcherGetChildren);
sagaMiddleware.run(watcherGetChildById);
sagaMiddleware.run(watcherUpdateChild);
sagaMiddleware.run(watcherRemoveChild);
sagaMiddleware.run(watcherGetReviews);
sagaMiddleware.run(watcherGenerateInvoice);